import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectDealershipSettings } from 'services/DealershipSettings/selectors';
import { FleetPlans } from 'constants/plans';
import { isAbove, isEqualOrAbove } from 'utils/plans.utils';

const usePlans = () => {
  const dealershipPlan = useSelector(selectDealershipSettings()).get('planId');

  const isDealershipPlanEqualOrAbove = useCallback(
    (plan: FleetPlans) => isEqualOrAbove(dealershipPlan, plan),
    [dealershipPlan]
  );

  const isDealershipPlanAbove = useCallback((plan: FleetPlans) => isAbove(dealershipPlan, plan), [dealershipPlan]);

  return {
    dealershipPlan,
    isDealershipPlanEqualOrAbove,
    isDealershipPlanAbove,
  };
};

export default usePlans;
